import React, { useState, useEffect } from "react";
import { Form, Row, Col, Skeleton, Select, Input, Button, Modal } from "antd";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useParams } from "react-router-dom";

function AddNewCard({onDataUpdate}) {
  const CREATECARD = gql`
    mutation createCard($createInput: CreateCardInput!) {
      createCard(createInput: $createInput) {
        id
      }
    }
  `;
  const GETUSERS = gql`
    query ($paginateInput: PaginateInput!, $searchInput: UserSearchInput!) {
      getUsers(paginateInput: $paginateInput, searchInput: $searchInput) {
        id
        name
        mobile
        userRole
      }
    }
  `;
  const { userId } = useParams();
  const [selectableUsers, setSelectableUsers] = useState([]);
  const [error, setError] = useState(null);
  const [getUsers, users] = useLazyQuery(GETUSERS, {
    onCompleted({ getUsers }) {
      const arrangedUsers = [];
      getUsers.map((user) => {
        arrangedUsers.push({
          value: user.id,
          label: user.name ? user.name : user.mobile,
        });
      });
      setSelectableUsers(arrangedUsers);
    },
  });
  const [form] = Form.useForm();
  const [runCreateCard, createCard] = useMutation(CREATECARD, {
    onCompleted(data) {
      Modal.success({
        title: "موفق",
        content: "کارت ثبت شد",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
        onOk: () => form.resetFields(),
      });
      onDataUpdate();
    },
    onError(err) {
      console.log("خطا: " + err.message);
      const errMsg = err?.graphQLErrors?.[0]?.message || err?.message;
      const isKnownError =
        typeof errMsg === "string" &&
        (errMsg.includes("این شماره کارت") ||
          errMsg.includes("این شناسه کارت") ||
          errMsg.includes("این کاربر دارای کارت فعال می باشد"));
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: isKnownError ? errMsg : "مشکلی پیش آمده! کارت ثبت نشد.",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
  });

  useEffect(() => {
    getUsers({
      variables: {
        paginateInput: {
          page: 1,
          perPage: 500,
        },
        searchInput: {
          userRole: ["USER"],
          confirmStatus: ["SUCCESS"],
        },
      },
    });
  }, []);

  const doCreateCard = (createInput) => {
    runCreateCard({
      variables: {
        createInput: {
          ...createInput,
          cardStatus: "DELIVERING",
          issuedAt: Date.now(),
        },
      },
    });
  };
  if (users.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  return (
    <>
      <Form layout="vertical" onFinish={doCreateCard} form={form}>
        <Row>
          <Col xs={24} md={12}>
            <Row>
              <Form.Item
                name="userId"
                id="userId"
                label="کاربر"
                rules={[
                  {
                    required: true,
                    message: "لطفا نام کاربر را انتخاب کنید!",
                  },
                ]}
                validateStatus={error && "error"}
              >
                <Select
                  showSearch
                  allowClear
                  loading={users.loading}
                  listHeight={200}
                  style={{
                    width: 200,
                  }}
                  placeholder={"کاربر"}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={selectableUsers}
                />
              </Form.Item>
            </Row>
            <Row gutter={30}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="cardIdentifier"
                  id="cardIdentifier"
                  label="شناسه کارت"
                  rules={[
                    {
                      required: true,
                      message: "لطفا شناسه کارت را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder={"شناسه کارت"} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="cardNo"
                  id="cardNo"
                  label="شماره کارت"
                  rules={[
                    {
                      required: true,
                      message: "لطفا شماره کارت را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder={"شماره کارت"} />
                </Form.Item>
              </Col>
            </Row>{" "}
            <Row>
              <Col span={24}>
                <Form.Item
                  label="توضیحات"
                  name="description"
                  rules={[{ required: false }]}
                >
                  <Input.TextArea rows={3} placeholder="توضیحات" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Button
          type="primary"
          htmlType="submit"
          loading={createCard.loading && true}
        >
          ارسال
        </Button>
      </Form>
    </>
  );
}

export default AddNewCard;
